import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowUpRight, ArrowRight, CheckCircle2 } from "lucide-react";

export default function PilotOfferStrip() {
  return (
    <section className="py-14 sm:py-16" data-testid="pilot-offer-strip">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-white via-slate-50/60 to-white p-10 sm:p-14 shadow-soft">
          <div
            className="absolute inset-0 opacity-[0.5]"
            style={{ backgroundImage: "radial-gradient(circle at 1px 1px, rgba(100,116,139,0.18) 1px, transparent 0)", backgroundSize: "22px 22px" }}
          />
          <div className="absolute -right-24 -top-24 size-72 rounded-full bg-[#0055FF]/[0.06] blur-3xl" />
          <div className="relative grid lg:grid-cols-[1.2fr_1fr] gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-[#0055FF]/20 bg-[#0055FF]/[0.06] px-3 py-1 text-[11px] uppercase tracking-[0.18em] font-semibold text-[#0055FF]">
                <span className="size-1.5 rounded-full bg-emerald-500 animate-pulse" />
                Funded pilot
              </div>
              <h3 className="mt-4 text-3xl sm:text-4xl lg:text-[40px] tracking-[-0.03em] font-semibold leading-[1.08] text-slate-900">
                Your first campaign, de-risked.
              </h3>
              <p className="mt-4 text-slate-600 text-[15.5px] leading-relaxed max-w-xl">
                Fund a wallet, set your criteria, and only pay for leads you accept. No retainers,
                no minimum term, pause delivery any time — your balance never expires.
              </p>
              <div className="mt-6 flex flex-wrap gap-x-7 gap-y-2.5 text-sm">
                {["Pay per accepted lead only", "100% exclusive — never resold", "Pause or scale instantly"].map((t, i) => (
                  <span key={i} className="inline-flex items-center gap-2 text-slate-700">
                    <CheckCircle2 className="size-4 text-emerald-600" /> {t}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex lg:justify-end gap-3 flex-wrap">
              <Link to="/start">
                <Button data-testid="pilot-start-cta" className="rounded-full px-6 h-12 bg-[#0055FF] text-white hover:bg-[#0044CC] font-semibold text-[15px]">
                  Start a pilot <ArrowUpRight className="size-4" />
                </Button>
              </Link>
              <Link to="/book-demo">
                <Button
                  variant="outline"
                  data-testid="pilot-talk-cta"
                  className="rounded-full px-6 h-12 border-slate-300 bg-white text-slate-900 hover:border-[#0055FF]/40 hover:text-[#0055FF] text-[15px]"
                >
                  Talk to us first <ArrowRight className="size-4" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
